export default __webpack_public_path__ + "static/metadyn-logo-9a2c505f6826204b3b77368dc4594a7a.png";